/* desk-v1-ann.js: copy of the live assets/erx-ann.js (2026-11-01) for the desks page. erx-ann.js - Black Friday announcement bar (snippets/erx-ann.liquid).
   0. Computer: drops the grey trust line when it would crowd the offers.
   1. Feed check: the desk offer (data-ann-box) needs the box-stock feed to be under 24 h old (same rule as
      assets/erx-bf-box.js). Older, in the future or unreadable: the desk offer is removed, the rest stays.
   2. Phone: rotate the lines every 6 s (7 s when there are only two). Pauses while hovered, focused, touched (8 s) or the tab is hidden;
      stops after 4 rounds on the first line; never rotates with prefers-reduced-motion. */
(function () {
  if (window.__erxAnn) return; window.__erxAnn = 1;
  var DEAD = 24 * 60 * 60 * 1000, EVERY = 6000, ROUNDS = 4;
  var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(bar) {
    var upd = bar.getAttribute('data-ann-upd');
    if (upd !== null) {
      var t = Date.parse(upd), age = Date.now() - t;
      if (isNaN(t) || age > DEAD || age < -5 * 60 * 1000) {
        bar.querySelectorAll('[data-ann-box]').forEach(function (e) { e.remove(); });
        if (bar.classList.contains('erx-ann--d') && !bar.querySelector('.erx-ann__o')) {
          var fb = bar.querySelector('[data-ann-fallback]'), tr = bar.querySelector('.erx-ann__trust');
          if (fb) fb.hidden = false; if (tr) tr.style.display = 'none';
        }
      }
    }
    /* computer: the grey trust line goes when it would sit closer than 96 px to the offers (longer LV / ET lines) */
    var offers = bar.querySelector('.erx-ann__offers'), trust = bar.querySelector('.erx-ann__trust');
    if (offers && trust) {
      var fit = function () {
        bar.classList.remove('is-tight');
        if (!trust.getClientRects().length) return;
        if (trust.getBoundingClientRect().left - offers.getBoundingClientRect().right < 96) bar.classList.add('is-tight');
      };
      fit(); addEventListener('resize', fit, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    }
    var ms = [].slice.call(bar.querySelectorAll('[data-ann-msg]'));
    if (!ms.length) return;
    /* phone: a tap anywhere on the line (the "Black Friday" label too) opens the line that is showing */
    var row = bar.querySelector('.erx-ann__row');
    if (row) {
      var mark = function () { var on = bar.querySelector('[data-ann-msg].is-on'); row.classList.toggle('has-link', !!on && on.tagName === 'A'); };
      row.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        var on = bar.querySelector('[data-ann-msg].is-on');
        if (on && on.tagName === 'A') on.click();
      });
      mark(); bar.addEventListener('erx-ann:change', mark);
    }
    if (!bar.querySelector('[data-ann-msg].is-on')) ms[0].classList.add('is-on');
    if (ms.length < 2 || still) return;
    var i = ms.indexOf(bar.querySelector('[data-ann-msg].is-on')), hover = 0, focus = 0, touchUntil = 0, steps = 0;
    bar.addEventListener('mouseenter', function () { hover = 1; });
    bar.addEventListener('mouseleave', function () { hover = 0; });
    bar.addEventListener('focusin', function () { focus = 1; });
    bar.addEventListener('focusout', function () { focus = 0; });
    bar.addEventListener('touchstart', function () { touchUntil = Date.now() + 8000; }, { passive: true });
    var every = ms.length < 3 ? 7000 : EVERY; /* two lines (desk and chair pages): a calmer pace */
    var timer = setInterval(function () {
      if (hover || focus || Date.now() < touchUntil || document.hidden || !bar.getClientRects().length) return;
      ms[i].classList.remove('is-on');
      i = (i + 1) % ms.length; steps++;
      ms[i].classList.add('is-on');
      bar.dispatchEvent(new Event('erx-ann:change'));
      if (steps >= ms.length * ROUNDS && i === 0) clearInterval(timer);
    }, every);
  }
  function run() { document.querySelectorAll('[data-erx-ann]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
